export default "__VITE_ASSET__AOfllf4o__"